import Phaser from 'phaser';
import { animationKey, characterFrames, type CharacterState, type Direction } from './SpriteExtractionConfig';
export class DirectionalSpriteController {
  direction: Direction = 'down';
  state: CharacterState = 'idle';
  private actionTime = 0;
  private elapsed = 0;
  constructor(private sprite: Phaser.GameObjects.Sprite, private character: string, private scale = 0.43) {
    sprite.setOrigin(0.5, 216 / 224).setPosition(0, 18).setScale(scale);
    this.update(0, false);
  }
  action(state: CharacterState, duration = 250): void { this.state = state; this.actionTime = duration; }
  update(delta: number, moving: boolean, direction = this.direction, danger = false): void {
    this.elapsed += delta;
    this.direction = direction;
    this.actionTime = Math.max(0, this.actionTime - delta);
    if (this.actionTime === 0) this.state = moving ? 'walk' : 'idle';
    const key = animationKey(this.character, this.state, this.direction);
    this.sprite.play(key, true).setFlipX(characterFrames(this.character, this.state, this.direction).flip);
    const bob = moving ? Math.sin(this.elapsed / 80) * 1.2 : Math.sin(this.elapsed / 500) * 0.4;
    this.sprite.setY(18 - Math.abs(bob));
    this.sprite.setScale(this.scale, this.scale * (1 + (moving ? 0 : Math.sin(this.elapsed / 500) * 0.008)));
    if (danger) this.sprite.setTint(0xffcc99); else this.sprite.clearTint();
  }
}
